import styled from 'styled-components'

export const OperationItemHeader = styled.div`
    cursor: pointer;
    width: 100%;
    height: 48px;
    background: var(--gray-100);
    display: flex;
    flex-wrap: nowrap;
    flex: row;
    padding: 16px;

    .operation-item-description {
        /* width: min-content; */
        font-family: var(--font-semibold);
        font-size: 13px;
        line-height: 16px;
        color: var(--gray-800);
        padding-left: 8px;
        vertical-align: middle;
    }

    .operation-item-degraded-barriers {
        text-align: right;
        font-size: 12px;
        line-height: 16px;
        color: var(--gray-800);
        margin: 0 35px 0 auto;
        vertical-align: middle;

        span {
            font-family: var(--font-semibold);
            font-size: 16px;
            line-height: 16px;
        }
    }

    .operation-item-expand {
        color: var(--blue-500);
        line-height: 16px;
        vertical-align: middle;
    }
`

export const OperationItemBowties = styled.div<{ isExpanded: boolean }>`
    padding: 16px;
    width: 100%;
    animation: ${props => (props.isExpanded ? 'inAnimation 350ms ease-in' : 'outAnimation 350ms ease-out')};
    display: ${props => (props.isExpanded ? 'flex' : 'none')};
    flex-direction: column;
    gap: 16px;

    @keyframes inAnimation {
        0% {
            opacity: 0;
            visibility: hidden;
        }

        100% {
            opacity: 1;
            visibility: visible;
        }
    }

    @keyframes outAnimation {
        0% {
            opacity: 1;
        }

        100% {
            opacity: 0;
            /* padding: 0; */
            /* height: 0; */
            visibility: hidden;
        }
    }

    .operation-bowtie-header {
        width: 100%;

        display: grid;
        grid-template-areas: 'DE ST BP BM';
        grid-template-columns: 1fr 64px 55px 55px;
        grid-template-rows: 1fr;
        gap: 12px;
        padding-bottom: 14px;
        border-bottom: 1px solid var(--gray-300);

        .operation-bowtie-degraded-count {
            grid-area: DE;
            margin-right: auto;
            font-size: 10px;
            line-height: 12px;
            color: var(--gray-700);

            div {
                font-size: 12px;
                color: var(--gray-800);

                span {
                    font-size: 16px;
                    font-family: var(--font-semibold);
                }
            }
        }

        .operation-bowtie-barrier-resume {
            font-size: 13px;
            line-height: 22px;
            color: var(--gray-600);
            text-align: center;

            &.prevention {
                grid-area: BP;
            }

            &.mitigation {
                grid-area: BM;
            }

            .operation-bowtie-barrier-label {
                font-size: 10px;
                line-height: 16px;
                width: 100%;
                color: var(--gray-800);
            }

            span {
                font-family: var(--font-semibold);
                font-size: 16px;
                color: var(--gray-800);
            }
        }
    }
`
